import {
  CustomTargetsDataFragmentFragment,
  StripeBillingInterval,
} from '@/__generated__/graphql.ts';
import { getMinPurchasableTargets } from '@/utils/paid-data.ts';

export type StepperPrice = {
  amount: number;
  interval: StripeBillingInterval;
  intervalCount: number;
};

export const getInitialTargetsCount = (
  customTargets: Pick<
    CustomTargetsDataFragmentFragment,
    'minTargets' | 'stepSize'
  >,
) => getMinPurchasableTargets(customTargets);

export const getNextValidTargetsCount = (
  currentCount: number,
  customTargets: Pick<
    CustomTargetsDataFragmentFragment,
    'minTargets' | 'stepSize'
  >,
) => {
  const floor = Math.max(currentCount + 1, customTargets.minTargets);
  return Math.ceil(floor / customTargets.stepSize) * customTargets.stepSize;
};
